
// Post Filter
import PostFilter from "../assets/components/post_filter.vue"
Vue.component('post-filter', PostFilter)

// Posts list
import Posts from "../assets/components/posts.vue"
Vue.component('posts', Posts)

// Single Post
import Post from "../assets/components/post.vue"
Vue.component('post', Post)
